import {
  ZodIssueCode,
  array,
  boolean,
  coerce,
  discriminatedUnion,
  literal,
  number,
  object,
  preprocess,
  string,
} from 'zod';

import {
  IS_INTEGER,
  IS_POSITIVE,
  IS_REQUIRED,
  isRangeBetween,
} from '@occc-app/lib/constants/validationMessages';

import { BasePromotionSchema } from './base-promotion.schema';

import { TransactionDiscountAwardType, PromotionType } from '../types';

const ProductGroupItemSchema = object({ id: string(), name: string() });

export const TransactionDiscountEarningMechanismSchema = discriminatedUnion('awardType', [
  object({
    awardType: literal(TransactionDiscountAwardType.PercentDiscount),
    purchaseAmountThreshold: number({ required_error: IS_REQUIRED }).gt(0, {
      message: IS_POSITIVE,
    }),
    percentDiscount: coerce
      .number({ message: IS_REQUIRED })
      .int({ message: IS_INTEGER })
      .min(0, { message: isRangeBetween(0, 100) })
      .max(100, { message: isRangeBetween(0, 100) }),
    ineligibleProductGroups: array(ProductGroupItemSchema).optional(),
    allowMultipleFulfillmentsPerProductGroupThreshold: boolean().optional(),
  }),
  object({
    awardType: literal(TransactionDiscountAwardType.MoneyDiscount),
    purchaseAmountThreshold: number({ required_error: IS_REQUIRED }).gt(0, {
      message: IS_POSITIVE,
    }),
    moneyDiscount: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
    ineligibleProductGroups: array(ProductGroupItemSchema).optional(),
    allowMultipleFulfillmentsPerProductGroupThreshold: boolean().optional(),
  }),
]).superRefine((data, ctx) => {
  if (data.awardType === TransactionDiscountAwardType.MoneyDiscount) {
    if (
      data.purchaseAmountThreshold !== undefined &&
      data.moneyDiscount !== undefined &&
      data.purchaseAmountThreshold < data.moneyDiscount
    ) {
      ctx.addIssue({
        code: ZodIssueCode.custom,
        path: ['purchaseAmountThreshold'],
        message: 'Purchase threshold cannot be lower than the discount amount',
      });
    }
  }
});

export const TransactionDiscountFormSchema = BasePromotionSchema.extend({
  offerType: literal(PromotionType.TransactionDiscount),
  transactionDiscount: preprocess((val) => val ?? {}, TransactionDiscountEarningMechanismSchema),
});
